export default __webpack_public_path__ + "static/media/3.2da11e98.jpg";